 $(document).ready(function(){
    $('.model-viewer-click').click(function(){
      $(this).parent().find('.shopify-model-viewer-ui__button').hide();
    })
  })
  
//   产品按钮位置错乱
  let btnBody = $(".product-shop").next(".groups-btn").html()
  if(btnBody !== undefined){
  	$(".product-shop form").append('<div class="groups-btn">' + btnBody + '</div>')
  	$(".product-shop").next(".groups-btn").remove()
  }
//   产品详情左图右文 tab
  $(function(){
    $(".productTab_content section").hide();
    $(".productTab_content section.active").show();
    $(".productTab ul li").hover(function(){
      let index = $(this).index();
      $(this).addClass("active").siblings().removeClass("active");
      $(".productTab_content section").hide();
      $(".productTab_content section").eq(index).show();
    })
  })
  //   产品配送说明
  // if (window.screen.width < 1024) {
  // 	var swiper = new Swiper('.swiper-container.swiper_delivery', {
  //       slidesPerView: 1,
		// keyboard : true,
		// virtualTranslate : true,
		// on:{
		// 	setTranslate: function(){
		// 		this.$wrapperEl.transition('')
		// 		TweenMax.to(this.$wrapperEl, 1.2, {x:this.translate, ease:Power4.easeOut})
				
		// 	}
		// },
  //       pagination: {
  //         el: '.swiper-pagination',
  //         clickable: true,
  //       },
  //   });
  // }
//   产品详情轮播图
    if (window.screen.width > 1024) {
      var swiper = new Swiper('.swiper-container.details_Swiper', {
        slidesPerView: 5,
        spaceBetween: 16,
        centeredSlides: true,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
	} else{
      var swiper = new Swiper('.swiper-container.details_Swiper', {
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: false,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
	}
    
//   产品详情 toggle
  $(function(){
	$(".leftsidebar_box dd").hide();
	$(".leftsidebar_box dl").eq(0).find("dd").addClass("product_toggle").show().siblings().find("img").addClass("toggleIcon_anima");
	
	$(".leftsidebar_box dt").click(function(){
		let index = $(this).parent().index();
		
		$(this).parent().find('dd').removeClass("product_toggle");
		$(".product_toggle").slideUp(); 
		$(this).parent().find('dd').addClass("product_toggle");
		
		$(this).parent().find('dd').slideToggle(function(){
		  if($(".leftsidebar_box dd").is(":visible")){
			$(".leftsidebar_box dl img").removeClass("toggleIcon_anima")
			$(".leftsidebar_box dl").eq(index).find("img").addClass("toggleIcon_anima")
		  }else{
			$(".leftsidebar_box dl img").removeClass("toggleIcon_anima")
		  }
		});
		
	});
  })


// 产品详情 table 切换
$(function(){
  $(".product_bottom .tabs__product-page .list-tabs .tab-title a").click(function(){
    if (window.screen.width > 1024) {
        $('html,body').animate({scrollTop:$('.product_bottom').offset().top+50}, 800);
    }else{
        $('html,body').animate({scrollTop:$('.product_bottom').offset().top-50}, 800);
    }
  })
})

if (window.screen.width > 1024) {
  $(document).on('wheel', function(event) {
      var deltaY = event.originalEvent.deltaY;
      if (deltaY < 0) {
        $("body.template-product .product_bottom .tabs__product-page .list-tabs").css("top","58px")
      }else{
        $("body.template-product .product_bottom .tabs__product-page .list-tabs").css("top","0")
      }
  });
}else{
  let elementTopfixed = $('.product_bottom .horizontal-tabs .list-tabs').offset().top
  $(window).on('scroll', function() {
    var elementTop = $('.product_bottom .horizontal-tabs .list-tabs').offset().top;
    var windowTop = $(window).scrollTop(); 
    if(windowTop >= elementTop-50){
      $(".product_bottom .horizontal-tabs .list-tabs").addClass("product_listTab_fixed")
    }
    if(windowTop < elementTopfixed-50){
      $(".product_bottom .horizontal-tabs .list-tabs").removeClass("product_listTab_fixed")
      
    }
  });
}



